module.exports = __webpack_public_path__ + "static/media/cover-back.10c06d2d.png";